// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"853":"glightbox","979":"swiper"}[chunkId] + ".min.js";
};